// src/app/Router.tsx
import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "../pages/LoginPage";
import AdminLayout from "../layout/AdminLayout";

import DashboardPage from "../pages/DashboardPage";
import PropertiesPage from "../pages/PropertiesPage";
import BookingsPage from "../pages/BookingsPage";
import PricingPage from "../pages/PricingPage";
import SettingsPage from "../pages/SettingsPage";
import NewPropertyPage from "../pages/NewPropertyPage";
import EditPropertyPage from "../pages/EditPropertyPage";
import BusinessSelectPage from "../pages/BusinessSelectPage";
import RequireAdminBusiness from "./RequireAdminBusiness";

export default function Router() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/dashboard" replace />} />

                <Route path="select-business" element={<BusinessSelectPage />} />

                <Route
                    path="dashboard"
                    element={
                        <RequireAdminBusiness>
                            <DashboardPage />
                        </RequireAdminBusiness>
                    }
                />

                <Route
                    path="properties"
                    element={
                        <RequireAdminBusiness>
                            <PropertiesPage />
                        </RequireAdminBusiness>
                    }
                />

                {/* ✅ ΠΡΟΣΟΧΗ: new route */}
                <Route
                    path="properties/new"
                    element={
                        <RequireAdminBusiness>
                            <NewPropertyPage />
                        </RequireAdminBusiness>
                    }
                />

                <Route
                    path="properties/:id"
                    element={
                        <RequireAdminBusiness>
                            <EditPropertyPage />
                        </RequireAdminBusiness>
                    }
                />

                <Route
                    path="bookings"
                    element={
                        <RequireAdminBusiness>
                            <BookingsPage />
                        </RequireAdminBusiness>
                    }
                />

                <Route
                    path="pricing"
                    element={
                        <RequireAdminBusiness>
                            <PricingPage />
                        </RequireAdminBusiness>
                    }
                />

                <Route
                    path="settings"
                    element={
                        <RequireAdminBusiness>
                            <SettingsPage />
                        </RequireAdminBusiness>
                    }
                />
            </Route>

            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
    );
}
